const INDIA_TIME_ZONE = 'Asia/Kolkata';

export const formatIndiaTimestamp = (value) => {
  if (!value) return 'Time unavailable';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Time unavailable';
  const parts = new Intl.DateTimeFormat('en-IN', {
    timeZone: INDIA_TIME_ZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date).reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
  return `${parts.day} ${parts.month} ${parts.year}, ${parts.hour}:${parts.minute} ${String(parts.dayPeriod || '').toUpperCase()} IST`;
};

export const chronological = (items) => [...items].sort((left, right) => {
  const leftTime = Date.parse(left.created_at || '') || Number.MAX_SAFE_INTEGER;
  const rightTime = Date.parse(right.created_at || '') || Number.MAX_SAFE_INTEGER;
  return leftTime - rightTime;
});

export const mostRecentFirst = (items) => [...items].sort((left, right) => {
  const leftTime = Date.parse(left.created_at || left.updated_at || '') || 0;
  const rightTime = Date.parse(right.created_at || right.updated_at || '') || 0;
  return rightTime - leftTime;
});

export const messageSenderLabel = (senderType) => senderType === 'counsel' ? 'Internal Counsel' : senderType === 'customer' ? 'Customer' : 'System';